import React, {Component} from 'react';
import './ProgressIndicator.css';
import PropTypes from 'prop-types';

export default class ProgressIndicator extends Component {
    render() {
        let divClassNames = [];
        divClassNames.push("ProgressIndicator");

        if (this.props.small) {
            divClassNames.push("ProgressIndicator--sm");
        }

        // ---

        let valueForBar = this.props.value;
        let barIsComplete = false;

        if (valueForBar <= 0) {
            valueForBar = 0;
        } else if (valueForBar >= 1) {
            valueForBar = 1;
            barIsComplete = true;
        }

        let barStyle = {
            width: `${valueForBar * 100}%`
        };

        // ---

        let barClassNames = ["ProgressIndicator__bar"];

        if (barIsComplete) {
            barClassNames.push("ProgressIndicator__bar--full");
        }

        // ---

        return (
            <div className={divClassNames.join(' ')}>
                <div className={barClassNames.join(' ')} style={barStyle}/>
            </div>
        );
    }
}

ProgressIndicator.propTypes = {
    value: PropTypes.number.isRequired,
    small: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Portal/Parts/ProgressIndicator.js